import { render } from "./rob.vue?vue&type=template&id=adf265ca&scoped=true"
import script from "./rob.vue?vue&type=script&lang=js"
export * from "./rob.vue?vue&type=script&lang=js"

import "./rob.vue?vue&type=style&index=0&id=adf265ca&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf265ca"],['__file',"src/views/rob.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "adf265ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('adf265ca', __exports__)) {
    console.log('reload')
    api.reload('adf265ca', __exports__)
  }
  
  module.hot.accept("./rob.vue?vue&type=template&id=adf265ca&scoped=true", () => {
    console.log('re-render')
    api.rerender('adf265ca', render)
  })

}


export default __exports__